import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as microsoftTeams from '@microsoft/teams-js';
import { appInsights } from 'lib/appInsights';
import msal, { getUser, loginRequest, clearInteractionProgress } from 'lib/msal';
import { Button, Block, translate } from '@haldor/ui';

var InteractionRequired = /*#__PURE__*/function (_Component) {
  _inherits(InteractionRequired, _Component);

  var _super = _createSuper(InteractionRequired);

  function InteractionRequired() {
    var _this;

    _classCallCheck(this, InteractionRequired);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = getUser();
      appInsights.trackTrace({
        message: "EDU012 - Token error (invalid_grant or interaction_required)"
      }, {
        error: _this.props.error
      });
    });

    _defineProperty(_assertThisInitialized(_this), "runLogin", function () {
      var request = loginRequest;

      if (_this.props.error != null) {
        if (_this.props.error.claims != null) {
          request.claims = _this.props.error.claims;
        }

        appInsights.trackTrace({
          message: 'EDU018 | Check claims on InteractionRequired page'
        }, {
          error: _this.props.error
        });
      }

      if (microsoftTeams.app.isInitialized()) {
        var url = '/Auth';

        if (_this.props.error != null) {
          if (_this.props.error.claims != null) {
            url += "?claims=".concat(encodeURI(_this.props.error.claims));
          }
        }

        microsoftTeams.authentication.authenticate({
          url: url
        }).then(function (response) {
          appInsights.trackTrace({
            message: 'EDU018a | MSTeams authenticate successCallback'
          }, {
            response: response
          });

          _this.props.history.replace('/');
        })["catch"](function (error) {
          appInsights.trackTrace({
            message: 'EDU018b | MSTeams authenticate failureCallback'
          }, {
            error: error
          });
        });
      } else {
        clearInteractionProgress();
        msal.loginRedirect(request);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderInformation", function () {
      if (_this.props.error != null) {
        if (_this.props.error.errorCode == 'interaction_required') {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('Sorry for bothering you')), /*#__PURE__*/React.createElement("p", {
            style: {
              marginTop: '1.5rem'
            }
          }, _this.props.translate('Something went wrong and you need to sign in again.')), getUser() != null ? /*#__PURE__*/React.createElement("p", {
            style: {
              marginTop: '1.65rem'
            }
          }, _this.props.translate('Currently logged in as'), " ", getUser().name, /*#__PURE__*/React.createElement("div", {
            className: "size-12 color--meta",
            style: {
              marginBottom: '.75rem'
            }
          }, getUser().username), /*#__PURE__*/React.createElement(Button, {
            onClick: _this.runLogin,
            style: {
              marginRight: 10
            }
          }, _this.props.translate('log-in')), /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick() {
              return msal.logout();
            }
          }, _this.props.translate('Log out'))) : null);
        }
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('you-are-almost-ready')), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '1.65rem'
        }
      }, _this.props.translate('consent-first-person-in-tenant-message')), /*#__PURE__*/React.createElement("a", {
        href: "https://portal.haldor.se",
        target: "_blank",
        style: {
          display: 'inline-block',
          marginTop: '1.65rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "primary"
      }, "Portal")), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '1.65rem'
        }
      }, _this.props.translate('consent-if-you-are-not-an-administrator-message')), getUser() != null ? /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '1.65rem'
        }
      }, _this.props.translate('Currently logged in as'), " ", getUser().name, /*#__PURE__*/React.createElement("div", {
        className: "size-12 color--meta",
        style: {
          marginBottom: '.75rem'
        }
      }, getUser().username), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return msal.logout();
        }
      }, _this.props.translate('Log out'))) : null);
    });

    return _this;
  }

  _createClass(InteractionRequired, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (window.location.pathname == '/tab-configure' || window.location.pathname == '/course-plan-configure') {
        return this.renderInformation();
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 650,
          margin: '0 auto',
          marginTop: '3rem'
        }
      }, /*#__PURE__*/React.createElement(Block, null, this.renderInformation())));
    }
  }]);

  return InteractionRequired;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps)(InteractionRequired));